var React = require('react');

function ClockEnd (props) {
    return React.createElement("svg",props,[React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M12 6v6h6","key":0}),React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M1 12c0-2.531.873-4.985 2.472-6.948C5.07 3.09 7.297 1.74 9.776 1.227c2.48-.512 5.059-.153 7.304 1.016 2.245 1.17 4.018 3.077 5.02 5.401 1.003 2.324 1.173 4.923.482 7.358-.69 2.436-2.2 4.558-4.274 6.01-2.073 1.451-4.584 2.143-7.109 1.959C8.675 22.787 6.291 21.737 4.45 20","key":1}),React.createElement("path",{"fill":"#737680","strokeWidth":"1.5","d":"M6.36 18.27L3.24 22.43 1.683 18.01l4.677.26z","key":2})]);
}

ClockEnd.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24","stroke":"#737680"};

module.exports = ClockEnd;

ClockEnd.default = ClockEnd;
